module.exports = __webpack_public_path__ + "media/img/frontend_application/footericon/linkedin-d2c4a2ade7d4ee147b6076e8cf5e7ceb.svg";